import React, { createContext, useContext, useState } from 'react';
import { useSelector } from 'react-redux';

// Create a context
const UserContext = createContext();

// Create a provider component
export const UserProvider = ({ children }) => {
  const { current } = useSelector((state) => state.user);
  const [value] = useState({
    role: current?.role,
    isUserReadOnly: current?.role === 'SUPPORT'
  });

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
};

// Custom hook for easier consumption
export const useUserContext = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUserContext must be used within a UserProvider');
  }
  return context;
};
